import React from "react";

import styled from "@emotion/styled";

const Item = styled.div`
  border: 1px solid #ebebeb;
  border-radius: 5px;
  padding: 11px 13px;
  margin-bottom: 8px;
  background: #fcfcfb;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  font-size: 11.5px;
  color: #767676;
  margin-bottom: 6px;
`;

const Meta = styled.span`
  b {
    color: #2b2b2b;
  }
`;

const Badge = styled.span`
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 11.5px;
  font-weight: 700;
  white-space: nowrap;
  background: ${({ $checked }) => ($checked ? "#eaf3ec" : "#fdecec")};
  color: ${({ $checked }) => ($checked ? "#2f7536" : "#c0392b")};
`;

const TypeTag = styled.span`
  display: inline-block;
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 10.5px;
  font-weight: 700;
  background: #eaf1fc;
  color: #2f5fce;
`;

const Content = styled.div`
  font-size: 13px;
  line-height: 1.55;
  color: #2b2b2b;
  white-space: pre-wrap;
  word-break: break-word;
`;

const Answer = styled.div`
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #ebebeb;
  font-size: 12.5px;
  color: #555;
  line-height: 1.5;
  white-space: pre-wrap;
`;

const ProcessInfo = styled.div`
  margin-top: 8px;
  font-size: 12px;
  color: #555;
  line-height: 1.5;

  b {
    color: #2b2b2b;
    font-weight: 700;
  }
`;

const EmptyText = styled.div`
  font-size: 13px;
  color: #999;
  text-align: center;
  padding: 20px 0;
`;

export default function CsHistoryList({ cses = [], emptyText }) {
  if (!cses.length) {
    return (
      <EmptyText>{emptyText || "해당 기간에 등록된 CS가 없습니다."}</EmptyText>
    );
  }

  return cses.map((cs) => {
    const processInfo = cs.getProcessInfo();
    const answer = cs.renderAnswer();

    return (
      <Item key={cs.id}>
        <Top>
          <Meta>
            등록구분: <b>{cs.renderRegistrationType() || "-"}</b>
            {cs.renderCreatedAt() ? ` · ${cs.renderCreatedAt()}` : ""}
            {cs.isReturn && <TypeTag>회수</TypeTag>}
          </Meta>
          <Badge $checked={!!cs.checked && !cs.deleted}>{processInfo.badge}</Badge>
        </Top>
        <Content>{cs.renderText() || "-"}</Content>
        {answer ? <Answer>기사님 답변: {answer}</Answer> : null}
        <ProcessInfo>
          CS처리 일시: <b>{processInfo.at || "-"}</b>
          {" · "}
          CS처리한 사용자: <b>{processInfo.user || "-"}</b>
        </ProcessInfo>
      </Item>
    );
  });
}
